'use client'

import { ExternalLink } from 'lucide-react'
import Link from 'next/link'
import { useTranslations } from 'next-intl'
import React, { Dispatch, SetStateAction } from 'react'

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'

import { Button } from '../ui/button'

interface Props {
  isOpen: boolean
  onClose: Dispatch<SetStateAction<boolean>>
}

const LegalDialog = ({ isOpen, onClose }: Props) => {
  const t = useTranslations('Common.Legal')
  const links = [
    {
      name: t('privacy.title'),
      url: 'https://kotae.ai/privacy',
    },
    {
      name: t('terms.title'),
      url: 'https://kotae.ai/terms',
    },
    {
      name: t('refund.title'),
      url: 'https://kotae.ai/refund',
    },
  ]
  return (
    <Dialog open={isOpen} onOpenChange={(open) => onClose(!open)}>
      <DialogContent className="bottom-0 top-auto flex max-w-full translate-y-0 flex-col gap-6 rounded-b-none rounded-t-[16px] sm:bottom-auto sm:top-1/2 sm:max-w-[550px] sm:-translate-y-1/2 sm:rounded-lg">
        <DialogHeader>
          <DialogTitle className="text-left text-lg font-semibold text-base-card-foreground">{t('title')}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-start">
          <ul className="flex flex-col gap-4">
            {links.map((link) => (
              <li key={link.name}>
                <Link href={link.url} target="_blank">
                  <Button variant="noneHover" className="flex items-center gap-2 hover:bg-base-accent">
                    {link.name}
                    <ExternalLink className="h-4 w-4" />
                  </Button>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default LegalDialog
